import { render, staticRenderFns } from "./restricted.vue?vue&type=template&id=60adcf10&"
import script from "./restricted.vue?vue&type=script&lang=js&"
export * from "./restricted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports